import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _queryUserMembersRequest = {};
var _queryUserMembersResponse = { userMembers: '_userMember' };
var _userMember = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixMembersUsermembersV1UserMembersUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/user-members-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/user-members',
                destPath: '/v1/user-members',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of user members, based on provided filters, sorting and paging. */
export function queryUserMembers(payload) {
    var _a = serializer(_queryUserMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryUserMembersResponse, {
        _userMember: _userMember,
    }).fromJSON;
    function __queryUserMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.usermembers.v1.user_member',
            method: 'POST',
            methodFqn: 'wix.members.usermembers.v1.UserMembers.QueryUserMembers',
            url: resolveWixMembersUsermembersV1UserMembersUrl({
                protoPath: '/v1/user-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryUserMembers.fromReq = fromReq;
    __queryUserMembers.__isAmbassador = true;
    return __queryUserMembers;
}
//# sourceMappingURL=http.impl.js.map